module.exports = __webpack_public_path__ + "static/sf-6a4abd43f6366d0c15c6fde755850f83.svg";